export function isPublished (i: any) {
  if (!i || !(typeof i === 'object') || !i.publishedAt) return false
  const d = new Date(i.publishedAt)
  return d.getMilliseconds() <= Date.now()
}

export function filterPublishableItem (list: any[]) {
  return list.filter((i) => i && isPublished(i))
}
